<template>
  <!-- OUTER WRAPPER -->
  <div class="relative min-h-screen bg-gray-100 flex items-center justify-center overflow-hidden">

    <!-- VECTOR IMAGE (ABOVE GRAY, BELOW CARD) -->
    <img
      :src="vectorArt"
      alt="Background Vector"
      class="absolute left-0 top-5
             w-72 md:w-96
             opacity-25
             pointer-events-none
             z-10"
    />

    <img
      :src="vectorArt"
      alt="Background Vector"
      class="absolute right-0 bottom-10
             w-72 md:w-96
             opacity-25
             pointer-events-none
             z-20"
    />
    <!-- WHITE CARD (TOP LAYER) -->
    <div class="relative z-20 container mx-auto max-w-4xl py-8 px-4">
      <div class="bg-white rounded-lg shadow-lg flex flex-col md:flex-row">
        <div class="md:w-1/2 flex justify-center items-center p-8"> <img src="../assets/images/contact.jpg" alt="Contact Vector" class="w-full h-full object-contain" /> </div>
        <!-- LEFT IMAGE / FORM SIDE -->
        <div class="md:w-1/2 p-8 w-full">
          <h2 class="text-2xl font-bold text-gray-800 mb-6 text-center">
            Contact Us
          </h2>

          <form @submit.prevent="handleSubmit" class="space-y-4">
            <div>
              <label class="block text-sm font-medium text-gray-700">Name</label>
              <input
                v-model="form.name"
                type="text"
                class="mt-1 block w-full px-3 py-2 border rounded-md"
                required
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700">Email</label>
              <input
                v-model="form.email"
                type="email"
                class="mt-1 block w-full px-3 py-2 border rounded-md"
                required
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700">Contact</label>
              <input
                v-model="form.contact"
                type="tel"
                class="mt-1 block w-full px-3 py-2 border rounded-md"
                required
              />
            </div>

            <div>
              <label class="block text-sm font-medium text-gray-700">Message</label>
              <textarea
                v-model="form.message"
                rows="4"
                class="mt-1 block w-full px-3 py-2 border rounded-md"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              class="w-full bg-[#FFE9A0] text-black py-2 rounded hover:bg-[#FFD580]"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import vectorArt from '@/assets/images/art33.png'
import Swal from 'sweetalert2'
export default {
  name: 'ContactForm',
  data() {
  
    return {
      vectorArt,
      form: {
        name: '',
        email: '',
        contact: '',
        message: ''
      }
    
  }
  },
  methods: {
    async handleSubmit() {
      // ✅ Use your live API base URL (fallback to localhost for dev)
      const API_BASE_URL =
        process.env.VUE_APP_API_BASE_URL || 'https://sanskritirdapoon.in/api';

      try {
        const response = await fetch(`${API_BASE_URL}/contact`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.form)
        });

        if (response.ok) {
          Swal.fire({
            icon: 'success',
            title: 'Sent!',
            text: 'Message sent successfully!',
            confirmButtonColor: '#BF3131'
          });
          // ✅ Reset form after successful submission
          this.form = { name: '', email: '', contact: '', message: '' };
        } else {
          const errorData = await response.text();
          console.error('Backend error:', errorData);
          Swal.fire({
            icon: 'error',
            title: 'Failed',
            text: 'Failed to send message. Please try again.',
            confirmButtonColor: '#BF3131'
          });
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred. Please try again later.',
          confirmButtonColor: '#BF3131'
        });
      }
    }
  }
}
</script>

<style scoped>
/* Ensure the unified container has consistent dimensions */
.container .bg-white {
  min-height: 450px; /* Set a minimum height for consistency */
  max-width: 1000px; /* Ensure the container doesn't exceed a reasonable width */
}

/* Ensure the image and form sections have equal dimensions */
.md\:w-1\/2 {
  flex: 1 1 0; /* Equal width for both sections */
}

/* Ensure the image fits within its section */
img {
  max-height: 100%;
  max-width: 100%;
}
</style>